import { Assets } from "assets/Assets";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components/macro";
import { device, toRem } from "theme/Breakpoints";
import { DefaultText } from "theme/GlobalElements";
import { colors } from "theme/Theme";
import { Service } from "../types";

interface OurServiceItemProps {
  item: Service;
}

const OurServiceItem: React.FC<OurServiceItemProps> = ({ item }) => {
  const location = useLocation();
  useEffect(() => {
    const hash = location.hash;
    var el = document.getElementById(hash.substring(1));
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  }, [location]);
  return (
    <OurServiceItemContainer id={item.elementId}>
      <InnerContainer>
        <ImageContainer>
          <ServiceImage src={item.image} />
        </ImageContainer>
        <ServiceTitle className="text-body">{item.title}</ServiceTitle>
        <ServiceText className="text-body">{item.content}</ServiceText>
      </InnerContainer>
    </OurServiceItemContainer>
  );
};

const OurServiceItemContainer = styled.div`
  flex: 1 100%;

  @media only screen and (${device.tablet}) {
    flex: 0 47%;
    margin-bottom: 3%;
  }
`;

const InnerContainer = styled.div`
  width: 280px;
  margin: 0 auto;

  @media only screen and (${device.laptop}) {
    width: 360px;
  }
`;

const ImageContainer = styled.div`
  height: 210px;

  @media only screen and (${device.laptop}) {
    height: 270px;
  }
`;

const ServiceImage = styled.img`
  width: 100%;
  height: 100%;
`;

const ServiceTitle = styled(DefaultText)`
  text-align: center;
  font-weight: 700;
  margin: 5px;

  @media only screen and (${device.laptop}) {
    margin: 10px;
  }
`;

const ServiceText = styled(DefaultText)`
  text-align: center;
`;

export default OurServiceItem;
